var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C9.38071 2 10.5 3.11929 10.5 4.5C10.4999 5.8806 9.38063 7 8 7C6.61937 7 5.50013 5.8806 5.5 4.5C5.5 3.11929 6.61929 2 8 2Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 8C9.2637 8.00003 10.4878 8.3671 11.5184 9.03809C10.0908 9.26881 9.0008 10.5073 9.0008 12C9.0008 12.7695 9.29308 13.469 9.76936 14H3.82502C2.67249 13.9998 1.70591 13.0807 2.08283 12.0371C2.39001 11.1872 2.89577 10.4059 3.57209 9.75781C4.74639 8.63265 6.33915 8 7.99983 8Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM12 11.5713C11.8422 11.5713 11.7139 11.6996 11.7139 11.8574V13C11.7139 13.1577 11.8423 13.2852 12 13.2852C12.1576 13.2849 12.2851 13.1576 12.2852 13V11.8574C12.2852 11.6998 12.1576 11.5715 12 11.5713ZM12 10.7148C11.8422 10.7148 11.7139 10.8422 11.7139 11C11.7139 11.1578 11.8422 11.2861 12 11.2861C12.1576 11.2859 12.2852 11.1577 12.2852 11C12.2851 10.8424 12.1576 10.7151 12 10.7148Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUserInfo);
export default __webpack_public_path__ + "static/media/Avatar_user_info.944d232469f2bbb845b560add04eb62f.svg";
export { ForwardRef as ReactComponent };